import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { ConnectedRouter, push } from 'react-router-redux';
import { Route, Switch } from 'react-router-dom';
import { ThemeProvider } from 'styled-components';
import { history } from './store/configureStore';
import * as types from './constants';
import './styles/fonts.css';
import theme from 'theme'; //eslint-disable-line
import ConfigManager from './common/configManager/configManager';
import Calendar from './containers/Calendar';
import CupCalendar from './containers/CupCalendar';
import MotorSportCalendar from './containers/MotorSportCalendar';
import TennisCalendar from './containers/TennisCalendar';
import CycleCalendar from './containers/CycleCalendar';
import VolleyCalendar from './containers/VolleyCalendar';
import VolleyCalendarChampionship from './containers/VolleyCalendarChampionship';
import BasketCalendarChampionship from './containers/BasketCalendarChampionship';
import BasketCalendarNba from './containers/BasketCalendarNba';
import RugbyCalendar from './containers/RugbyCalendar';

class App extends Component {
  static childContextTypes = {
    breakpoints: PropTypes.arrayOf(PropTypes.number),
  };

  constructor(props) {
    super(props);
    this.state = {
    };
    this.theme = Object.assign({}, theme);
    this.props.actions.initDictionary();
  }

  getChildContext = () => ({
    breakpoints: (process.env.REACT_APP_SITE === 'gazzetta' || process.env.REACT_APP_SITE === 'fcinter' || process.env.REACT_APP_SITE === 'calcionapoli1926')
      ? [320, 599, 1024, 1440] : [320, 767, 767, 1440],
  });

  renderCalendar = () => (
    <Route
      path={ConfigManager.getRoute('calendar')}
      render={() => (
        <Calendar
          dictionary={this.props.dictionary}
          actions={this.props.actions}
          calendar={this.props.calendar}
          hasHighlights={this.props.hasHighlights}
          betMatch={this.props.betMatch}
        />
      )}
    />);

  renderCupCalendar = () => (
    <Route
      path={ConfigManager.getRoute('cupcalendar')}
      render={() => (
        <CupCalendar
          dictionary={this.props.dictionary}
          actions={this.props.actions}
          calendar={this.props.cupCalendar}
          cupTabbar={this.props.cupTabbar}
          hasHighlights={this.props.hasHighlights}
          isSpecial={this.props.isSpecial}
          betMatch={this.props.betMatch}
          isFootballSerieB={this.props.isFootballSerieB}
          isUefaCompetition={this.props.isUefaCompetition}
        />
      )}
    />);

  renderMotorSportCalendar = () => (
    <Route
      path={ConfigManager.getRoute('motorsportcalendar')}
      render={() => (
        <MotorSportCalendar
          dictionary={this.props.dictionary}
          actions={this.props.actions}
          motorSportCalendar={this.props.motorSportCalendar}
        />
      )}
    />);

  renderTennisCalendar = () => (
    <Route
      path={ConfigManager.getRoute('tenniscalendar')}
      render={() => (
        <TennisCalendar
          dictionary={this.props.dictionary}
          actions={this.props.actions}
          tennisCalendar={this.props.tennisCalendar}
          currentTennisPhase={this.props.currentTennisPhase}
        />
      )}
    />);

  renderCycleCalendar = () => (
    <Route
      path={ConfigManager.getRoute('cyclecalendar')}
      render={() => (
        <CycleCalendar
          dictionary={this.props.dictionary}
          actions={this.props.actions}
          cycleCalendar={this.props.cycleCalendar}
        />
      )}
    />);

  renderVolleyCalendar = () => (
    <Route
      path={ConfigManager.getRoute('volleycalendar')}
      render={() => (
        <VolleyCalendar
          dictionary={this.props.dictionary}
          actions={this.props.actions}
          volleyCalendar={this.props.cupCalendar}
          cupTabbar={this.props.cupTabbar}
          hasHighlights={this.props.hasHighlights}
          isSpecial={this.props.isSpecial}
          betMatch={this.props.betMatch}
        />
      )}
    />
  );

  renderVolleyCalendarChampionship = () => (
    <Route
      path={ConfigManager.getRoute('volleycalendarchampionship')}
      render={() => (
        <VolleyCalendarChampionship
          dictionary={this.props.dictionary}
          actions={this.props.actions}
          calendar={this.props.calendar}
          cupTabbar={this.props.cupTabbar}
          volleyCalendar={this.props.cupCalendar}
        />
      )}
    />
  );

  renderBasketCalendarChampionship = () => (
    <Route
      path={ConfigManager.getRoute('basketcalendarchampionship')}
      render={() => (
        <BasketCalendarChampionship
          dictionary={this.props.dictionary}
          actions={this.props.actions}
          calendar={this.props.calendar}
          cupTabbar={this.props.cupTabbar}
          basketCurrent={this.props.basketCurrent}
        />
      )}
    />
  );

  renderNba = () => (
    <Route
      path={ConfigManager.getRoute('nbacalendar')}
      render={() => (
        <BasketCalendarNba
          dictionary={this.props.dictionary}
          actions={this.props.actions}
          calendar={this.props.calendar}
          nbaCurrentDay={this.props.nbaCurrentDay}
          cupTabbar={this.props.cupTabbar}
          basketCurrent={this.props.basketCurrent}
        />
      )}
    />
  );

  renderRugbyCalendar = () => (
    <Route
      path={ConfigManager.getRoute('rugbycalendar')}
      render={() => (
        <RugbyCalendar
          dictionary={this.props.dictionary}
          actions={this.props.actions}
          calendar={this.props.calendar}
          cupTabbar={this.props.cupTabbar}
        />
      )}
    />
  );

  render() {
    const {
      isCup,
      isSpecial,
      isMotorSport,
      isTennis,
      isCycling,
      isVolley,
      isVolleyChampionship,
      isBasketChampionship,
      isNba,
      isRugby, isBasketSerieA, isFootballSerieB,
    } = this.props;
    return (
      <ThemeProvider theme={this.theme}>
        <ConnectedRouter history={history}>
          <Switch>
            {!isCup && !isSpecial && !isMotorSport && !isTennis && !isCycling && !isNba && !isRugby &&
            !isVolley && !isVolleyChampionship && !isBasketChampionship && !isBasketSerieA && !isFootballSerieB && this.renderCalendar()}
            {(isCup || isSpecial || isFootballSerieB) && !isMotorSport && !isTennis && !isCycling && !isNba && !isRugby &&
            !isVolley && !isVolleyChampionship && !isBasketChampionship && !isBasketSerieA && this.renderCupCalendar()}
            {isMotorSport && this.renderMotorSportCalendar()}
            {isTennis && this.renderTennisCalendar()}
            {isCycling && this.renderCycleCalendar()}
            {isVolley && this.renderVolleyCalendar()}
            {isVolleyChampionship && this.renderVolleyCalendarChampionship()}
            {(isBasketChampionship || isBasketSerieA) && this.renderBasketCalendarChampionship()}
            {isNba && this.renderNba()}
            {isRugby && this.renderRugbyCalendar()}
          </Switch>
        </ConnectedRouter>
      </ThemeProvider>
    );
  }
}

App.propTypes = {
  actions: PropTypes.any,
  calendar: PropTypes.any,
  hasHighlights: PropTypes.bool,
  dictionary: PropTypes.any,
  cupTabbar: PropTypes.any,
  cupCalendar: PropTypes.any,
  isCup: PropTypes.bool,
  isSpecial: PropTypes.bool,
  motorSportCalendar: PropTypes.any,
  tennisCalendar: PropTypes.any,
  isMotorSport: PropTypes.bool,
  isTennis: PropTypes.bool,
  isCycling: PropTypes.bool,
  isVolley: PropTypes.bool,
  isVolleyChampionship: PropTypes.bool,
  isBasketChampionship: PropTypes.bool,
  isNba: PropTypes.bool,
  currentTennisPhase: PropTypes.any,
  cycleCalendar: PropTypes.any,
  betMatch: PropTypes.any,
  nbaCurrentDay: PropTypes.any,
  basketCurrent: PropTypes.any,
  isRugby: PropTypes.bool,
  isBasketSerieA: PropTypes.bool,
  isFootballSerieB: PropTypes.bool,
  isUefaCompetition: PropTypes.bool,
};

export default connect(
  state => ({
    calendar: state.calendarReducer.get('calendar'),
    hasHighlights: state.calendarReducer.get('hasHighlights'),
    location: state.router.location,
    dictionary: state.dictionaryReducer.dictionary,
    cupTabbar: state.calendarReducer.get('cupTabbar'),
    cupCalendar: state.calendarReducer.get('cupCalendar'),
    motorSportCalendar: state.calendarReducer.get('motorSportCalendar'),
    tennisCalendar: state.calendarReducer.get('tennisCalendar'),
    cycleCalendar: state.calendarReducer.get('cycleCalendar'),
    currentTennisPhase: state.calendarReducer.get('currentTennisPhase'),
    betMatch: state.bettingReducer.betting,
    nbaCurrentDay: state.calendarReducer.get('nbaCurrentDay'),
    basketCurrent: state.calendarReducer.get('basketCurrent'),
  }),
  dispatch => ({
    actions: {
      push: url => dispatch(push(url)),
      getCalendar: (sportId, competitionId, seasonId) =>
        dispatch({
          type: types.GET_CALENDAR_REQUEST, sportId, competitionId, seasonId,
        }),
      getDayCalendar: (sportId, competitionId, day, seasonId) =>
        dispatch({
          type: types.GET_DAY_CALENDAR_REQUEST, sportId, competitionId, day, seasonId,
        }),
      getParamDayCalendar: (sportId, competitionId, day, seasonId) =>
        dispatch({
          type: types.GET_QUERY_PARAM_CALENDAR_REQUEST, sportId, competitionId, day, seasonId,
        }),
      getCupTabbar: (sportId, competitionId, seasonId, phase = false, subPhase = false) =>
        dispatch({
          type: types.GET_CUP_TABBAR_REQUEST, sportId, competitionId, seasonId, phase, subPhase,
        }),
      getCupCalendar: (sportId, competitionId, phase, subPhase, seasonId) =>
        dispatch({
          type: types.GET_CUP_DAY_CALENDAR_REQUEST, sportId, competitionId, phase, subPhase, seasonId,
        }),
      getMotorSportCalendar: (sportId, competitionId, seasonId) =>
        dispatch({
          type: types.GET_MOTORSPORT_CALENDAR_REQUEST, sportId, competitionId, seasonId,
        }),
      getCycleCalendar: (sportId, competitionId, seasonId) =>
        dispatch({
          type: types.GET_CYCLE_CALENDAR_REQUEST, sportId, competitionId, seasonId,
        }),
      getTennisCalendar: (sportId, competitionId, order, seasonId, phase) =>
        dispatch({
          type: types.GET_TENNIS_CALENDAR_REQUEST, sportId, competitionId, order, seasonId, phase,
        }),
      getVolleyCalendar: (sportId, competitionId, order, seasonId) =>
        dispatch({
          type: types.GET_VOLLEY_CALENDAR_REQUEST, sportId, competitionId, order, seasonId,
        }),
      getVolleyTabbar: (sportId, competitionId, seasonId, isCup = false, phase = false, subPhase = false) =>
        dispatch({
          type: types.GET_VOLLEY_TABBAR_REQUEST, sportId, competitionId, seasonId, isCup, phase, subPhase,
        }),
      getBasketTabbar: (sportId, competitionId, seasonId, phase = false, subPhase = false) =>
        dispatch({
          type: types.GET_BASKET_TABBAR_REQUEST, sportId, competitionId, seasonId, phase, subPhase,
        }),
      toggleHighlights: checked =>
        dispatch({ type: types.TOGGLE_HIGHLIGHTS, checked }),
      initDictionary: () =>
        dispatch({ type: types.INIT_DICTIONARY }),
      getBetMatches: (sportId, competitionId, betterName) =>
        dispatch({
          type: types.GET_BET_REQUEST,
          sportId,
          competitionId,
          betterName,
        }),
      getNbaCalendar: (sportId, competitionId, date) =>
        dispatch({
          type: types.GET_NBA_CALENDAR_REQUEST,
          sportId,
          competitionId,
          date,
        }),
      getRugbyTabbar: (sportId, competitionId, seasonId, phase = false, subPhase = false) =>
        dispatch({
          type: types.GET_RUGBY_TABBAR_REQUEST, sportId, competitionId, seasonId, phase, subPhase,
        }),
    },
  }),
)(App);



// WEBPACK FOOTER //
// ./src/App.js